'use client';

import { setAuthCookieAction } from '@insta-club/action';
import { ApiKeys, fetcher } from '@insta-club/api';
import { ArrowIcon, ChevronIcon, LockIcon, PenIcon } from '@insta-club/components';
import { useCustomForm } from '@insta-club/hooks';
import { useSessionStore } from '@insta-club/state';
import { Button, Form } from '@insta-club/ui';
import { LoginWithPasswordFormValues, loginWithPassword } from '@insta-club/validator';
import Link from 'next/link';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { SubmitHandler } from 'react-hook-form';
import toast from 'react-hot-toast';
import PssswordInput from 'src/libs/ui/input/password';

function PasswordForm() {
    const router = useRouter();
    const searchParams = useSearchParams();
    const username = searchParams.get('username');

    const form = useCustomForm(loginWithPassword);

    useEffect(() => {
        if (!username) {
            router.push('/auth/sign-in');
        }
    }, [username, router]);

    const onSubmit: SubmitHandler<LoginWithPasswordFormValues> = async (data) => {
        try {
            const { password } = data;
            const res: { admin: boolean; token: string; user: object; status: number } = await fetcher(
                ApiKeys.LOGIN,
                'web',
                'POST',
                {
                    body: {
                        username,
                        password
                    }
                }
            );
            if (res.token && res.status !== 400) {
                const cookie = await setAuthCookieAction(res?.token);
                if (cookie?.success) {
                    useSessionStore.getState().updateSession();
                    router.push('/dashboard');
                    return;
                } else {
                    toast.error(cookie.error ?? 'مشکلی پیش آمده');
                }
            }
            toast.error('رمز عبور  اشتباه میباشد');
        } catch (err: unknown) {
            if (err instanceof Error) {
                toast.error('خطای ناشناخته رخ داده است');
            } else {
                toast.removeAll();
                form.setError('password', {
                    message: (err as { error: { message: string } })?.error.message || 'خطا در اعتبار سنجی کد تایید'
                });
            }
        }
    };

    return (
        <>
            <p className='mt-6 mb-2 text-center text-sm font-normal text-gray-500'>
                رمز عبور حساب کاربری خود را وارد کنید
            </p>
            <div className='mb-6 flex items-center justify-center'>
                <span className='ml-2 text-base font-semibold text-gray-600'>{username}</span>
                <Link href={`/auth/sign-in`} className='text-primary-600 flex items-center text-sm font-normal'>
                    <PenIcon className='ml-1' />
                    ویرایش
                </Link>
            </div>
            <Form form={form} onSubmit={onSubmit}>
                <PssswordInput name='password' inputType='text' label='رمز عبور' containerClassName='mb-2' />
                <Button
                    loading={form.formState.isSubmitting}
                    type='submit'
                    size='lg'
                    fullWidth
                    className='mt-6 mb-6'
                    icon={<ArrowIcon className='rotate-180 text-white' />}
                    iconPosition='end'
                >
                    <span className='text-base font-semibold'>مرحله بعد</span>
                </Button>
            </Form>
            <Link href={`/auth/otp?username=${username}&exist=true&method=login`}>
                <div className='mb-6 flex items-center justify-between rounded-2xl bg-gray-100 px-6 py-3.5'>
                    <div className='flex items-center'>
                        <LockIcon className='text-gray-500' />
                        <span className='mr-2.5 text-base font-normal text-gray-600'>دریافت کد یکبار مصرف</span>
                    </div>
                    <ChevronIcon className='text-gray-500' />
                </div>
            </Link>
            <div className='text-center'>
                <Link
                    className='text-primary-500 mb-6 block text-sm font-normal'
                    href={`/auth/forgot-password?username=${username}`}
                >
                    فراموشی رمز عبور
                </Link>
            </div>
        </>
    );
}

export default PasswordForm;

